module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/layout/components/footer/footer.component.css
// module id = ./src/app/containers/layout/components/footer/footer.component.css
// module chunks = main